import { Component, Inject, Input, OnInit, Output } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { EventEmitter } from "@angular/core";
import * as _ from "lodash";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import {
  GeoDevicesService,
  LastDataDevice,
} from "src/app/services/mapa/geodevices.service";
import { DeviceModel } from "src/app/models/device.model";
import { GetDatePipe } from "src/app/pipes/pipes/pipe-date.pipe";
import { TimezoneService } from "src/app/services/timezone.service";
import moment from "moment-timezone";
import { LoginService } from "src/app/services/login/login.service";

export interface LastDataModel {
  uuid?: string;
  nombreDispositivo: string;
  mediciones: Medicion[];
  medicionesAgrupadas: any;
  medicionesTable: (Medicion | GroupBy)[];
  children: LastDataModel[];
  childrenRequest?: Observable<DeviceModel[]>;
}

export interface Medicion {
  nombre: string;
  stats_last: number;
  lastFecha: string;
  unidad: string;
  codigo: string;
  nombreCode: string;
  descripcion: string;
  // agrupacion: {
  //   uuid: string;
  //   nombre: string;
  //   nombreCode: string;
  // }
}

export interface GroupBy {
  codigo: string;
  isGroupBy: boolean;
}

export interface MedicionesTable {
  Nombre: string;
  Medidas: any[];
}

@Component({
  selector: "app-device-datos",
  templateUrl: "./device-datos.component.html",
  styleUrls: ["./device-datos.component.scss"],
  providers: [
    GetDatePipe,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
  ],
})
export class DeviceDatosComponent implements OnInit {
  @Input() loading: boolean;
  @Input() deviceId: string = "";
  @Input() isModal = true;
  @Input() lastDataDeviceMapped: LastDataModel = null;
  @Input() selectedLanguage: string;
  @Output() hideEventEmitter = new EventEmitter<boolean>();

  displayedColumns: string[] = [
    "codigo",
    "nombre",
    "lastFecha",
    "stats_last",
    "unidad",
  ];
  dataSource: LastDataDevice[] = [];

  lastDataDeviceMapped$: Observable<LastDataModel>;
  // lastDataDevice$: Observable<LastDataDevice>;
  loadingText = "LOADING.DEVICES";

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { device: string; selectedDataTypes: string[] },
    private geoDevicesService: GeoDevicesService,
    private getDatePipe: GetDatePipe,
    private timeZoneService: TimezoneService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    //IsModal = true se abre al invocarlo desde la pantalla de mapa
  }

  ngOnChanges(changes: any): void {
    if (changes.selectedLanguage) {
      this.selectedLanguage = changes.selectedLanguage.currentValue;
      this.getDevicesLastData(this.selectedLanguage);
    }
  }

  getDevicesLastData(language: string) {
    if (this.isModal && this.data.device !== "") {
      this.lastDataDeviceMapped$ = this.geoDevicesService
        .getLastDataDispositivo(this.data.device)
        .pipe(
          map((lastData) => {
            let lastDataMapped: LastDataDevice;
            if (this.data.selectedDataTypes.length > 0) {
              lastDataMapped = {
                nombre: lastData.nombre,
                labels: lastData.labels,
                uuid: lastData.uuid,
                estructura: lastData.estructura,
                tiene: lastData.tiene.filter((tiene) =>
                  this.data.selectedDataTypes.includes(tiene.es.uuid)
                ),
              };
            } else {
              lastDataMapped = {
                nombre: lastData.nombre,
                labels: lastData.labels,
                uuid: lastData.uuid,
                estructura: lastData.estructura,
                tiene: lastData.tiene,
              };
            }
            return lastDataMapped;
          }),
          map((device) => {
            let lastDataMapped: LastDataModel = {
              uuid: device.uuid,
              nombreDispositivo: device.nombre,
              mediciones: _.flattenDeep(
                device.tiene.map((tiene) => {
                  let dato: Medicion;
                  let lastFecha;
                  const timezone = this.loginService.currentUserValue.timeZone;
                  if (!_.isNil(tiene) && !_.isNil(tiene.lastFecha)) {
                    lastFecha = moment
                      .unix(Number(tiene.lastFecha) / 1000)
                      .tz(timezone)
                      .format("YYYY-MM-DD HH:mm:ss");
                  }
                  dato = {
                    nombre: "",
                    stats_last: !_.isNil(tiene)
                      ? Number(tiene.lastValor)
                      : null,
                    lastFecha: !_.isNil(tiene) ? lastFecha : null,
                    // lastFecha: !_.isNil(tiene.lastEntrada)?  tiene.lastEntrada.lastFecha: "",
                    codigo: tiene.es.codigo,
                    unidad: tiene.es.unidad,
                    nombreCode: tiene.es.nombreCode,
                    descripcion: tiene.es.descripcion,
                  };
                  switch (language) {
                    case "en":
                      dato.nombre = tiene.es.nombre_en;
                      break;
                    case "es":
                      dato.nombre = tiene.es.nombre_es;
                      break;
                    default:
                      dato.nombre = tiene.es.nombre_es;
                  }
                  return dato;
                  // })
                })
              ).filter(
                (dato) => dato.codigo !== "record" && dato.codigo !== "otros"
              ),
              //}), //.filter(dato => dato.codigo !== null),
              medicionesAgrupadas: "",
              medicionesTable: [],
              children: [],
            };
            return lastDataMapped;
          }),
          map((device) => {
            device.medicionesAgrupadas = _.groupBy(
              device.mediciones,
              (group) => group.codigo
            );
            let record: (Medicion | GroupBy)[] = [];
            Object.entries(device.medicionesAgrupadas).forEach((entry) => {
              let groupBy: GroupBy = {
                codigo: entry[0],
                isGroupBy: true,
              };
              record.push(...device.medicionesAgrupadas[entry[0]]);
            });

            device.medicionesTable = record;
            return device;
          })
        );
    }
  }

  isGroup(index, item): boolean {
    return item.isGroupBy;
  }

  // detectChanges() {
  //   this.timeZoneService.currentTimeZone$.subscribe((data: string) => {
  //     this.timezoneBS.next(data);
  //   });
  // }
}
